<template>
  <div id="indicatorlist" class="panel is-mobile">
    <div class="fl-container">
      <div class="dropdown" v-bind:class="{ 'is-active': preSavedPresets }">
        <div class="dropdown-trigger">
          <button class="button" aria-haspopup="true" aria-controls="dropdown-menu" v-on:click="preSavedPresets = !preSavedPresets">
            <span>Opgeslagen perioden</span>
            <span class="icon is-small">
               <i v-if="preSavedPresets" class="fas fa-angle-up" aria-hidden="true"></i>
              <i v-else class="fas fa-angle-down" aria-hidden="true"></i>
            </span>
          </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a v-for="(preset, index) in presets" :key="preset.id"
                v-bind:class="{ 'is-active': preset.active }" v-on:click="selectPeriod(preset)" class="dropdown-item">
              {{ preset.name }}
            </a>
            <hr class="smallHr" />
              <a v-for="(preset, index) in userPresets" :key="preset.id"
                v-bind:class="{ 'is-active': preset.active }" v-on:click="selectPeriod(preset)" class="dropdown-item">
              {{ preset.name }}
            </a>
          </div>
        </div>
</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import constants from '../../constants'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'IndicatorList',
  props: {
    activeLocation: Object,
  },
  data() {
    return{
      preSavedPresets:false
    }
  },
  computed: {
    ...mapGetters({
      presets: 'dataFilterPresets',
      userPresets: 'dataFilterUserPresets',
    }),
  },
  methods: {
    selectPeriod(preset) {
      this.preSavedPresets = false

      this.$store.commit('setPresetActivePreset', preset)
      this.$store.commit('setDateFilterStartDate', preset.filter.startDate)
      this.$store.commit('setDateFilterEndDate', preset.filter.endDate)

      // Update data sources
      this.$store.dispatch('fetchEvents')
      this.$store.dispatch('fetchTrackers')
      this.$store.commit('setMapDataUpdate', true)

      //Turn on maps layers

      //Set context visualisation
      let layerId = undefined
      if(preset.type == "Antea"){
          layerId = constants.MAP_LAYER_ANTEA_ID
      }else if(preset.type == "Tracker"){
          layerId = constants.MAP_LAYER_TRACKERS_ID
      }

      this.$emit('onSelectedPreset', {
            maplayer: layerId,
            layer: {
              type: preset.type,
              id: layerId
            },
          })
    }
  }
}
</script>

<style scoped>
.border {
  border: 1px solid #dbdbdb;
  border-radius: 10px;
  min-width: 100px;
  text-align: center;
  padding: 5px 15px;
}

.fl-container {
  display: flex;
  height: 36px;
}

.fl-container span {
  margin: auto 12px;
}

span.fav-label {
  width: 170px;
}
.no-period {
  font-style: italic;
}

ul {
  padding: 0;
}

li {
  float: left;
  margin-right: 10px;
  padding: 10px;
}

li.active {
  background-color: #00d1b2;
}
li.active a {
  color: white;
}

.smallHr{
margin: .0.2rem 0;
}
</style>
